"use strict";
// tslint:disable
// eslint-disable
/**
 * API Key Management API
 * API for CRUDing API Keys
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function KeyOwnerFromJSON(json) {
    return KeyOwnerFromJSONTyped(json, false);
}
exports.KeyOwnerFromJSON = KeyOwnerFromJSON;
function KeyOwnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'displayName': json['displayName'],
        'email': json['email'],
    };
}
exports.KeyOwnerFromJSONTyped = KeyOwnerFromJSONTyped;
function KeyOwnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'displayName': value.displayName,
        'email': value.email,
    };
}
exports.KeyOwnerToJSON = KeyOwnerToJSON;
